<div class="main-page">
  <div class="container">
    <div class="member-discount-top">
      <div class="innerPage member-discount-area">
        <ngx-ui-loader fgsSize="50" [fgsType]="spinnerType"></ngx-ui-loader>

        <div class="setting-screen-area">
          <span class="nav-divnk">Design Member Discount</span>
        </div>
        <!-- <div class="content-part"><img src="assets/logo-5.png"></div> -->
        <div class="ad-image">
          <h5 style="width: 100px; font-weight: 800; position: absolute;">Step 1</h5>
          <img [src]="eventImage ? eventImage : 'assets/blank.webp'" />
          <div class="upload-btn-wrapper">
            <button type="button" (click)="open(content)" class="btn btn-style color file_btn">
              Select image
            </button>
          </div>
        </div>
        <div class="ad-image2">
          <h5 style="width: 100px; font-weight: 800; position: absolute;">Step 2</h5>
          <div class="upload-btn-wrapper">
            <button type="button" (click)="openLink(1)" class="btn btn-style color file_btn">
              Edit / Design your discount
            </button>
          </div>
        </div>
        <div>
          <form class="form-signin" [formGroup]="form" (ngSubmit)="onSubmit(form.value)">
            <h5 style="width: 200px; font-weight: 800; color: white; margin-top: 40px;">Discount Preview:</h5>
            <!-- <span (click)="openLink(1)" class="txt-span">{{btnText}}</span> -->
            <div class="form-group textarea-container">
              <textarea readonly rows="8" cols="50" type="text" class="form-control" formControlName="description"
                placeholder="Discount description"></textarea>
              <p class="terms">{{terms}}</p>

              <!-- <span  class="input-group-addon cursor">
                <i class="fa fa-edit"></i>
              </span> -->
            </div>
            <!-- *ngIf="userData?.subscriptionPlanType == '64831349522e756b4497aa01'" -->
            <div class="save-button-area">
              <button type="button" (click)="openInfo(myModal)" class="remove_btn">Remove Discount</button>
              <button (click)="onSubmit(form.value)" type="submit" class="btn btn-primary save-button">
                Save
              </button>
            </div>
          </form>
          <div class="kp-encourage-banner"
            *ngIf="kingdomPartnerStatus !== 'approved' && kingdomPartnerStatus !== 'pending'">
            <p>
              <i class="fa fa-shield-alt"></i>
              You've created a discount! Apply for <strong>Kingdom Partner</strong> status to get your badge and unlock
              extra benefits.
            </p>
            <button class="btn-kp-apply" (click)="goToSubscriptionPage()">
              Apply for Kingdom Partner
            </button>
          </div>

          <div class="kp-encourage-banner" *ngIf="kingdomPartnerStatus === 'pending'">
            <p><i class="fa fa-clock"></i> Your Kingdom Partner application is pending admin approval.</p>
          </div>

          <div class="kp-encourage-banner kp-approved" *ngIf="kingdomPartnerStatus === 'approved'">
            <p><i class="fa fa-check-circle"></i> You're a Kingdom Partner! 🎉</p>
          </div>
          <a href="https://ravel.faith/policies/ravel-terms/" target="_blank"><b>Terms of Services</b> </a>
        </div>
      </div>
    </div>
  </div>

  <ng-template #content let-modal>
    <div class="modal-header main-backgroundcolor color">
      <h4 class="modal-title" id="modal-basic-title" style="color: #fff">
        Select Image
      </h4>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span style="color: #fff" aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div>
        <div class="responsive" *ngFor="let props of galleryArr; let i = index">
          <div class="gallery">
            <div class="image-wrapper" [class.selected]="selectedItem == i" (click)="selectImage(props, i)"
              tabindex="0">
              <img class="zoom" [src]="renderImage(props)" alt="Gallery image" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer" style="width: 60%; margin-left: 20%;">
      <button type="button" class="btn main-backgroundcolor color" (click)="modal.close('Save click'); addimageForm()"
        style="background-color: green !important;">
        Select
      </button>
      <button type="button" class="btn main-backgroundcolor color" (click)="modal.close('Save click'); photoGal()">
        Add Photos
      </button>
    </div>
  </ng-template>
</div>

<ng-template #myModal let-modal>
  <div class="modal-header" style="justify-content: end;">
    <div class="row">
      <div class="col-md-6">
        <div type="button" aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true">X</span>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-body location">
    <h5>
      <!-- If you want to remove your discount you must or cancel your <a  (click)="modal.dismiss('')" routerLink="/mysubscration">
      subscription -->

      Per the terms of your subscription, you must offer a Member Discount.
      If you want to remove it, please choose a different <a (click)="modal.dismiss('')" routerLink="/mysubscration">
        subscription </a> plan
    </h5>

  </div>
</ng-template>